import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Row } from "antd";
import { spacing } from "../../../../../../styles/spacing.js";
/**
 * Renders a translation legend.
 * @param hidden Whether the legend is hidden.
 * @param items The legend items to display.
 * @param style The style to apply to the legend.
 * @returns The translation legend component.
 */ function Legend({ hidden, items, style }) {
    return /*#__PURE__*/ _jsx(Row, {
        hidden: hidden,
        style: style,
        gutter: [
            spacing.layout.content.marginMedium,
            spacing.layout.content.marginSmall
        ],
        children: items.map((item, index)=>/*#__PURE__*/ _jsx(LegendItem, {
                icon: item.icon,
                text: item.text
            }, index))
    });
}
/**
 * Renders a translation legend item.
 * @param icon The icon to display.
 * @param text The text to display.
 * @returns The translation legend item component.
 */ function LegendItem({ icon, text }) {
    return /*#__PURE__*/ _jsxs(Col, {
        style: {
            fontSize: "small"
        },
        children: [
            icon,
            " ",
            text
        ]
    });
}
export { Legend, LegendItem };
